export const setMonthlyData = (id, valueData) => {
    let tempData = []
    valueData.forEach(data => {
        if (id === data.id) {
            tempData = data.monthlyDataList
        }
    })
    return tempData
}

export const getTableHeaders = (id, valueData) => {
    let tempMonthlyData = setMonthlyData(id, valueData);
    let tempHeaders = [];
    tempMonthlyData.forEach(data => {
        tempHeaders.push(data.headerName)
    })
    return tempMonthlyData
}

export const getTableValues = (value) => {
    let regex = /[^\.,0-9]+/g;
    var matches = value.replace(regex, '');
    return matches
}
